import { Controller } from "@hotwired/stimulus"
import Pickr from "@simonwep/pickr"

export default class extends Controller {
    static targets = ["input", "button"]

    connect() {
        this.pickr = Pickr.create({
            el: this.buttonTarget,
            theme: "classic",
            default: this.inputTarget.value || "#FF965E",
            components: {
                preview: true,
                opacity: true,
                hue: true,
                interaction: {
                    hex: true,
                    rgba: true,
                    hsla: true,
                    hsva: true,
                    cmyk: true,
                    input: true,
                    save: true,
                }
            },
            i18n: {

        'ui:dialog': 'color picker dialog',
        'btn:toggle': 'toggle color picker dialog',
        'btn:swatch': 'color swatch',
        'btn:last-color': 'use previous color',
        'btn:save': '保存',
        'btn:cancel': 'Cancel',
        'btn:clear': 'Clear',

        'aria:btn:save': 'save and close',
        'aria:btn:cancel': 'cancel and close',
        'aria:btn:clear': 'clear and close',
        'aria:input': 'color input field',
        'aria:palette': 'color selection area',
        'aria:hue': 'hue selection slider',
        'aria:opacity': 'selection slider'
        }
        })

        this.pickr.on("save", (color) => {
        const hex = color.toHEXA().toString()
        this.inputTarget.value = hex
        this.pickr.hide()
        })
    }

}